import { useSelector } from "react-redux";
import { CareCommentAnalysisData } from "../../../../domain/care_comment_analysis/CareCommentAnalysisData";
import { State } from "../../../../state/store";

export function useCareCommentAnalysisDataList() {
    const { list, registerDateStart, registerDateEnd } = useSelector((state: State) => state.adminCareCommentAnalysis.searchedAnalysisDataList);

    return {
        list: list.map(jsonData => CareCommentAnalysisData.fromJson(jsonData)),
        registerDateStart: registerDateStart,
        registerDateEnd: registerDateEnd
    };
}